/**
 * Styling constants
 */
export const comboboxRootHeight = "28px";
export const comboboxRootMaxWidth = "283px";

/**
 * Common ids for pinned comboboxes
 */
export const commonLeadingComboboxIds = [
  "FontPicker",
  "FontName",
  "FontName_New",
  "Floatie-FontName-Floatie",
  "Floatie-FontPicker-Floatie",
];
export const commonTrailingComboboxIds = [
  "FontSize",
  "Floatie-FontSize-Floatie",
];
